<template>
  <div :class="['plate',mode]">
    <div class="title1">题材详情</div>

    <div class="company_item" v-for="item in info">
      
      <h1 class="color63">{{item.name}}</h1>
      <div v-for="list in item.list">
        <h2 v-if="list.keyword != item.name" class="w50">{{list.keyword}}</h2>  
        <p>{{list.mainpoint_content}}</p>
      </div>

    </div>


  </div>
</template>

<script>
export default {
  props:{
    info:{
      type:Array,
      default:[],
    }
  },
  data(){
        return{
            mode:this.$route.params.mode,//light,dark
            code:this.$route.params.code,//sz000070
        }
    },
    created() {
        console.log(this.$route.params);
    },
}

</script>
<style lang="scss" scoped>
  @import "~@/assets/sass/globalapp.scss";
  .plate{
    padding: rem2(10px) rem2(12px);
    .company_item{

      line-height: 150%; 
      font-size: rem2(13px);

      h1{
        margin: rem2(10px) 0;
      }
      h2{
        font-weight: 600;
        margin: rem2(10px) 0;
      }
      p{
        margin: rem2(10px) 0;
      }
    }
  }

  .light_mode{

  }

  .dark_mode{
    .plate{

    }
    
  }
</style>